import { useQuery } from "@tanstack/react-query";
import type { MarketplaceListingOptionDTO } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/marketplace/listings — the ~8-row link-picker source, also
// used by the partner-detail Marketplace listing card to resolve a linked
// id to its name. `configured: false` when MARKETPLACE_* secrets are unset
// (fail-soft — the picker renders its "not configured" note).
//
// staleTime 60s: the marketplace catalogue changes rarely and several
// surfaces (picker + card resolution) share the one key, so avoid refetch
// churn when a dialog opens.

export type MarketplaceListingsResponse = {
  configured: boolean;
  listings: MarketplaceListingOptionDTO[];
};

export function useMarketplaceListings(enabled = true) {
  return useQuery<MarketplaceListingsResponse, ApiClientError>({
    queryKey: queryKeys.admin.marketplaceListings(),
    queryFn: () =>
      apiFetch<MarketplaceListingsResponse>("/admin/marketplace/listings"),
    staleTime: 60_000,
    enabled,
  });
}
